export default __webpack_public_path__ + "static/media/payfort.ec8e9979.png";